'use strict';

var log = require('../../log/Log').channel('SleepService');
var defaults = require('../../defaults/Defaults');
var moment = require('moment');
var momentDurationFormatSetup = require("moment-duration-format");
require('./DeviceService');

momentDurationFormatSetup(moment);

angular.module('inara')
.directive('sleepClickBlock', function() {
    return {
        restrict: 'E',
        scope: {},
        template: '<div class="sleep-click-block" ' +
                       'ng-class="{ \'sleep-click-block-hide\' : isHidden(), ' +
                                   '\'sleep-click-block-cleaning\' : isCleaning() }">' +
                       '<div class="row row-center full-height" ng-if="isCleaning()">' +
                           '<div class="col">' +
                               '<div class="row hcenter-children">' +
                                   '<div class="cleaning-icon"></div>' +
                               '</div>' +
                               '<p class="cleaning-message">{{getCleaningModeMsg()}}</p>' +
                               '<p class="cleaning-message">{{getCleaningTimeLeftMsg()}}</p>' +
                           '</div>' +
                       '</div>' +
                  '</div>',
        replace: true,
        controller: [ '$scope', '$element', '$attrs', 'SleepService', 'gettextCatalog',
            function ($scope, $element, $attrs, SleepService, gettextCatalog) {
                $scope.isHidden = function() { 
                    return !SleepService.isSleeping() && !SleepService.isCleaning();
                };
                $scope.isCleaning = function() {
                    return SleepService.isCleaning();
                };
                $scope.getCleaningModeMsg = function() {
                    /// Screen cleaning mode message
                    return gettextCatalog.getString('Screen cleaning mode activated');
                };
                $scope.getCleaningTimeLeftMsg = function() {
                    /// Time remaining where timeLeft is for example, '30 seconds'
                    return gettextCatalog.getString('{{timeLeft}} remaining',
                        { timeLeft: moment.duration(
                            SleepService.getCleaningTimeLeft(), 'seconds')
                            .format('s __') });
                };
            }
        ]
    };
})
.provider('SleepService', function() {
    var options = {
        timeout: defaults.inara.sleepTimeout * 60, // seconds
        wakeEvents: 'mousemove keydown DOMMouseScroll mousewheel ' +
            'mousedown touchstart touchmove touchrepeat scroll'
    };

    this.timeout = function(seconds) {
        if (seconds === false) {
            options.timeout = 0;
        } else if (angular.isNumber(seconds) && seconds >= 0) {
            options.timeout = seconds;
        } else {
            throw new Error('timeout must be >= 0 or false');
        }
    };

    this.wakeEvents = function(events) {
        options.wakeEvents = events;
    };

    this.$get = ['$rootScope', '$timeout', '$interval', '$document', 
        '$q', 'DeviceService', SleepService];

    function SleepService($rootScope, $timeout, $interval, $document, 
        $q, DeviceService) {
        var STARTING = 0, AWAKE = 1, SLEEPING = 2, DISABLED = 3, CLEANING = 4;
        var state = STARTING;
        var sleepPromise = null;
        var cleaningPromise = null;
        var cleaningSavedEnable = true;
        var cleaningTimeLeft = 0;
        var deviceReady = false;

        log.info('initializing');

        $document.on('deviceready', function() {
            deviceReady = true;
            DeviceService.acquireFullWakeLock() // keep native sleep awake
                .then(wake);
        });

        $document.find('html').on(options.wakeEvents, function(event) {
            if (event.type !== 'mousemove' || 
                angular.isUndefined(event.movementX) || 
                (event.movementX || event.movementY)) {
                $timeout(wake, 1);
            }
        });

        $rootScope.$on('SleepService', function(event, args) {
            if (args === null || !angular.isDefined(args)) return;
            switch(args.toLowerCase()) {
                case 'sleep':
                    sleep();
                    break;
                case 'wake':
                    wake(true);
                    break;
                case 'startclean':
                    startClean();
                    break;
                case 'endclean':
                    endClean();
                    break;
                default:
                    log.warning('Unknown SleepService argument: ' + args);
                    break;
            }
        });

        return {
            getCleaningTimeLeft: getCleaningTimeLeft,
            enable: enable,
            isCleaning: isCleaning,
            isSleeping: isSleeping,
            isDisabled: isDisabled,
            setSleepTimeout: setSleepTimeout
        };

        function cancelCleaningInterval() {
            if (cleaningPromise) $interval.cancel(cleaningPromise);
            cleaningTimeLeft = 0;
        }

        function cancelSleepTimeout() {
            if (sleepPromise) $timeout.cancel(sleepPromise);
        }

        function getCleaningTimeLeft() {
            return cleaningTimeLeft;
        }

        function enable(shouldEnable) {
            if (!deviceReady) {
                log.warning('enable: device not ready!');
                return;
            }
            if (state === CLEANING) {
                // if CLEANING, save the intended enabled state for when cleaning ends
                cleaningSavedEnable = shouldEnable;
                log.debug('saving enabled state = ' + cleaningSavedEnable + ' while cleaning');
                return;
            }
            if (shouldEnable && state !== DISABLED ||
                !shouldEnable && state === DISABLED) {
                return;
            }
            state = STARTING;
            // Prevent call to $apply when enabling/disabling since $digest
            // will already be in progress.
            wake(true);
            if (!shouldEnable) {
                cancelSleepTimeout();
                state = DISABLED;
            }
        }

        function endClean() {
            if (state !== CLEANING) return;
            log.debug('endClean()');
            if (cleaningSavedEnable) {
                // force state to AWAKE so wake() will function
                state = AWAKE;
                wake(true);
            } else {
                state = DISABLED;
            }
            log.debug('returning to state = ' + getStateName(state));
        }

        function getStateName(state) {
            switch(state) {
                case 0:
                    return 'STARTING';
                case 1:
                    return 'AWAKE';
                case 2:
                    return 'SLEEPING';
                case 3:
                    return 'DISABLED';
                case 4:
                    return 'CLEANING';
                default:
                    return 'Unknown';
            }
        }

        function isCleaning() {
            return state === CLEANING;
        }

        function isDisabled() {
            return state === DISABLED;
        }

        function isSleeping() {
            return state === SLEEPING;
        }

        function onCleaningIntervalTick() {
            if (cleaningTimeLeft > 0) {
                cleaningTimeLeft--;
            }
            if (cleaningTimeLeft === 0) {
                cancelCleaningInterval();
                endClean();
            }
        }

        function resetCleaningInterval() {
            cancelCleaningInterval();
            cleaningTimeLeft = defaults.inara.screenCleaningTimeout;
            cleaningPromise = $interval(onCleaningIntervalTick, 1000);
        }

        function resetSleepTimeout() {
            cancelSleepTimeout();
            sleepPromise = $timeout(sleep, options.timeout * 1000);
        }

        function setSleepTimeout(seconds) {
            options.timeout = seconds;
            resetSleepTimeout();
        }

        function sleep() {
            if (state === SLEEPING ||
                state === DISABLED ||
                state === CLEANING) {
                return $q.resolve();
            }
            log.debug('sleep()');
            state = SLEEPING;
            cordova.plugins.Keyboard.close();
            return DeviceService.loaded()
                .then(DeviceService.setSleep);
        }

        function startClean() {
            if (state === CLEANING) return;
            log.debug('startClean()');
            wake(true);
            cleaningSavedEnable = state !== DISABLED;
            state = CLEANING;
            cancelSleepTimeout();
            resetCleaningInterval();
        }

        function wake(noApply) {
            if (state === DISABLED || state === CLEANING) return $q.resolve();
            resetSleepTimeout();
            if (state === AWAKE) return $q.resolve();
            log.debug('wake()');
            if (noApply) {
                state = AWAKE;
            } else {
                $rootScope.$apply(function() {
                    state = AWAKE;
                });
            }
            return DeviceService.loaded()
                .then(DeviceService.setWake);
        }
    }
});
